import React from 'react';
import { Field, Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { Box, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import ButtonMain from '../Shared/ButtonMain';
import TextFieldMain from '../Shared/TextFieldMain';
import useForgotPasswordHook from './useForgotPasswordHook';
import LoaderMain from '../Shared/LoaderMain';
import FundoPadrao from '../Login/FundoPadrao';

const ForgotPassword = () => {
  const {
    isPending,
    handleFormSubmit,
    validateInputs,
    limpaMsgErro,
    isRecoveredPassword,
    message,
    loginPending
  } = useForgotPasswordHook();

  return (
    <FundoPadrao>
      <CardContent>
        {loginPending && <LoaderMain bgTransparencia="0" />}
        <Grid container className={`${loginPending ? 'display-none' : ''}`}>
          <Grid item xl={1} lg={1} md={1} sm={1} xs={1} />
          <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
            {isRecoveredPassword === false && (
              <>
                <Typography variant="h5" className="texto-negrito texto-centro label-acessar-conta">
                  Redefinir senha
                </Typography>
                <Formik
                  initialValues={{
                    email: '',
                    documento: ''
                  }}
                  validate={validateInputs}
                  onSubmit={handleFormSubmit}
                  validateOnChange={false}
                  validateOnBlur={false}
                >
                  {({ values, isSubmitting }) => {
                    const emailIsFilled = !!values.email?.trim();
                    const documentoIsFilled = !!values.documento?.trim();

                    return (
                      <Form>
                        <Grid container>
                          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Typography className="texto-cor-label">CPF</Typography>
                            <Field
                              variant="filled"
                              type="text"
                              name="documento"
                              titulo="CPF"
                              id="documento"
                              size="small"
                              inputClassName={`input-login w-100 ${documentoIsFilled ? 'is-filled' : ''}`}
                              placeholder="000.000.000-00"
                              uppercase={true}
                              component={TextFieldMain}
                              autoComplete="off"
                              tipoMascara="CPFMask"
                              disabled={isPending || isSubmitting}
                            />

                            <Typography className="texto-cor-label mt-3">Login</Typography>
                            <Field
                              variant="filled"
                              placeholder="Email ou login"
                              type="text"
                              name="email"
                              titulo="Login"
                              id="email"
                              size="small"
                              component={TextFieldMain}
                              onChangeInput={limpaMsgErro}
                              inputClassName={`input-login w-100 ${emailIsFilled ? 'is-filled' : ''}`}
                              uppercase={false}
                              autoComplete="off"
                              disabled={isPending || isSubmitting}
                            />

                            {message && (
                              <Typography
                                variant="subtitle1"
                                className="texto-danger pad-10 texto-centro"
                              >
                                {message}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid container spacing={2} className="mt-2">
                          <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <ButtonMain
                              type="submit"
                              tipoBotao="principal"
                              disabled={
                                isPending || isSubmitting || !documentoIsFilled || !emailIsFilled
                              }
                              className={`button-cor-cliente min-heith-42 ${isPending ? 'loading' : ''}`}
                            >
                              {!isPending && <>Solicitar redefinição</>}
                              {isPending && <CircularProgress size={24} color="inherit" />}
                            </ButtonMain>

                            <Box className="text-center mt-5 mb-5">
                              <Typography variant="subtitle1" className="texto-link-redefinir">
                                Já tem uma conta? &nbsp;
                                <Link
                                  className="link-criar-conta"
                                  disabled={isPending || isSubmitting}
                                  to="/login"
                                >
                                  <Typography>Ir para login</Typography>
                                </Link>
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Form>
                    );
                  }}
                </Formik>
              </>
            )}

            {!isRecoveredPassword === false && (
              <Box className="box-email-enviado">
                <Typography variant="h5" className="texto-negrito texto-centro label-acessar-conta">
                  Solicitação enviada
                </Typography>

                <Typography
                  variant="subtitle1"
                  className="texto-descricao texto-cor-cinza-escuro texto-centro"
                >
                  Nossa equipe enviará uma nova senha em breve para o e-mail cadastrado.
                </Typography>

                <Box className="text-center mt-5 mb-5">
                  <Typography variant="subtitle1" className="texto-link-redefinir">
                    <Link className="link-criar-conta" to="/login">
                      <Typography>Voltar para início</Typography>
                    </Link>
                  </Typography>
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </FundoPadrao>
  );
};

export default ForgotPassword;
